// extracted by mini-css-extract-plugin
export default {"card":"PlayerView_card__e30zW"};